import util from '../../../../libs/util';

/**
 * 权限
 * */
export default {
  namespaced: true,
  state: {
    // 用户权限
    userPermissions: null
  },
  getters: {
    /**
     * @description 获取权限
     * */
    permission(state) {
      return state.userPermissions;
    }
  },
  actions: {
    /**
     * @description 加载权限
     * @param {Object} state vuex state
     * @param {*} key 权限Key
     */
    async load({ state }) {
      if (state.userPermissions == null) {
        state.userPermissions = {};
        let permissions = await util.db.get('permission').value();

        if (permissions) {
          state.userPermissions = permissions;
        }
      }
    },
    /**
     * @description 设置权限
     * @param {Object} state vuex state
     * @param {*} data 内容
     */
    async set({ state }, data) {
      let permissions = {};
      data.forEach(permission => {
        permissions[permission] = true;
      });

      util.db.set('permission', permissions).write();
      state.userPermissions = permissions;
    }
  }
};
